import * as React from 'react';
import { useContext } from 'react';
import { ToolUserClaims } from './ToolUserClaims';

export const ToolAuthorisationClaimsContext = React.createContext<ToolUserClaims | null>(null);
export const useToolAuthorisationClaimsContext = () => useContext(ToolAuthorisationClaimsContext);
